import React, {useEffect, useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Branches.scss";
import BranchesTemplate from "./BranchesTemplate";
import NewBranchTemplate from "./NewBranchTemplate";
import {useDispatch, useSelector} from "react-redux";
import {fetchBranches} from "../../features/branchesSlice";
import EmployeeBranchesTemplate from "./EmployeeBranchesTemplate";
import {setStatus} from "../../features/authorizationSlice";

function Branches() {
    const {status} = useSelector((state) => state.authorization);
    const [activeButton, setActiveButton] = useState({name: "Branches"});

    const handleButtonClick = (event) => {
        setActiveButton({name: event.target.innerText});
    };

    const entityRole = sessionStorage.getItem("EntityRole");

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchBranches());
    }, []);

    useEffect(() => {
        if (status === "COMPLETE") {
            setActiveButton({name: "Branches"});
            setStatus("");
        }
    }, [status]);

    return (
        <>
            <HeaderComponent title="Branches"/>
            <div className="BranchesPage">
                <div className="container-fluid Branchescontainer">
                    <div className="row">
                        <div className="col-lg-10 col-sm-12 ">
                            <div className="top_section">
                                <button className={`navButton ${activeButton.name === "Branches" ? "active" : ""}`}
                                        onClick={handleButtonClick}>Branches
                                </button>
                                {entityRole !== "Supervisor" && (
                                    <>
                                        <button
                                            className={`navButton ${activeButton.name === "Employees" ? "active" : ""}`}
                                            onClick={handleButtonClick}>Employees
                                        </button>

                                        <button
                                            className={`navButton ${activeButton.name === "+ New Branch" ? "active" : ""}`}
                                            onClick={handleButtonClick}>+ New Branch
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>
                    <div className="row">
                        <div>
                            {activeButton.name === "Branches" && <BranchesTemplate setActiveButton={setActiveButton}/>}
                            {activeButton.name === "Employees" &&
                                <EmployeeBranchesTemplate setActiveButton={setActiveButton}/>}
                            {entityRole !== "Supervisor" ? (
                                activeButton.name === "+ New Branch" &&
                                <NewBranchTemplate setActiveButton={setActiveButton}/>
                            ) : (<></>)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Branches;